<template>
  <div id="app" class="d-flex">
    <!-- Loading -->
    <div
      v-if="isLoading"
      class="overlay d-flex justify-content-center align-items-center text-light"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <router-view />

    <!-- Modal -->
    <common-modal :dialogId="dialogId" @hide="clearError" :title="title">
      <template #body>
        <div class="body">
          <p v-if="subtitle" class="mt-2">{{ subtitle }}</p>
          {{ content }}
        </div>
      </template>
      <template #footer>
        <basic-button
          class="float-right"
          :isCancel="true"
          :label="$t('{SYSTEM0102}')"
          @click="clearError"
        />
      </template>
    </common-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Components
import CommonModal from "@/components/common/Modal";

// Constants
import { errorModalId } from "@/constants/dialog.js";

export default {
  name: "App",
  data() {
    return {
      dialogId: errorModalId
    };
  },
  components: {
    CommonModal
  },
  computed: {
    ...mapGetters({
      isLoading: "loading/isLoading",
      isError: "error/isError",
      title: "error/title",
      content: "error/content",
      subtitle: "error/subtitle"
    })
  },
  watch: {
    isError(value) {
      if (value) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show(this.dialogId);
    },
    closeModal() {
      this.$bvModal.hide(this.dialogId);
    },
    clearError() {
      if (this.isError) {
        this.$store.dispatch("error/resetError");
      }
    }
  }
};
</script>

<style lang="scss">
/* English */
html:lang(en) body {
  font-family: "Noto Sans", sans-serif;
}

/* Japanese */
html:lang(ja) body {
  font-family: "Noto Sans JP", sans-serif;
}

/* Chinese */
html:lang(zh) body {
  font-family: "Noto Sans TC", sans-serif;
}

/* Vietnam */
html:lang(vi) body {
  font-family: "Open Sans", sans-serif;
}

#app {
  font-size: 16px;
  height: 100vh;
  width: 100vw;
  position: relative;
  color: $black;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $dark-gray;
  opacity: 0.5;
  z-index: 9999;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 1.2rem;
  color: $dark-gray;
}
</style>
